import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import modalUtils from '../../../../../../../qti/utils/ModalUtils';
import snapshotsService from '../../../../../../../services/SnapshotsService';
import { t } from '../../../../../../../services/i18nService';
import SnapshotListItem from './SnapshotListItem';
import sessionReader from '../../../../../../../store/readHelpers/SessionReader';

import ckWrapperStyles from '../../ckeditorWrapper.scss';
import styles from './snapshotsModal.scss';

class SnapshotsModal extends React.Component {
    static propTypes = {
        ckeditor: PropTypes.object.isRequired, // the ckeditor instance
        closeCallback: PropTypes.func.isRequired,
        interactionId: PropTypes.string.isRequired,
        questionId: PropTypes.number.isRequired,
        snapshots: PropTypes.array.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    storeSnapshot() {
        snapshotsService.storeSnapshot(
            this.props.questionId,
            this.props.interactionId,
            this.getData(),
        );
    }

    restoreSelectedSnapshot() {
        const mostRecentSnapshot = this.getMostRecentSnapshot();
        const currentData = this.getData();

        /*
         * Make a snapshot of the current value if it is changed since the last snapshot
         * and not identical to the snapshot being restored
         * and not empty.
         */
        if (currentData !== ''
            && currentData !== mostRecentSnapshot.content
            && currentData !== this.state.selectedSnapshot.content) {
            this.storeSnapshot();
        }

        if (sessionReader.shouldDebugSnapshots()) {
            window.console.log('Restoring snapshot', this.state.selectedSnapshot.content);
        }

        this.props.ckeditor.setData(this.state.selectedSnapshot.content);
        this.setState({ selectedSnapshot: undefined });
        this.props.closeCallback();
    }

    getData() {
        return this.props.ckeditor.getData();
    }

    getMostRecentSnapshot() {
        const { snapshots } = this.props;
        return snapshots.length ? snapshots[snapshots.length - 1] : null;
    }

    formatDateTime(timeStamp, locale = sessionReader.getLanguage()) {
        return new Date(timeStamp).toLocaleString(locale);
    }

    selectSnapshot = (snapshot) => {
        this.setState({ selectedSnapshot: snapshot });
    };

    onRestoreButtonClick = () => {
        this.restoreSelectedSnapshot();
    };

    onCancelButtonClick = () => {
        this.setState({ selectedSnapshot: undefined });
    };

    render() {
        return (
            <Modal
                contentLabel="Snapshots"
                isOpen
                style={modalUtils.snapshotsModalStyles}
            >
                <div className={`${ckWrapperStyles.snapshotsToolWrapper} ${styles.snapshotsModal}`}>
                    <div className={styles.headerContainer}>
                        <div className={styles.header}>
                            <h2>{t('ckeditor.snapshots.header')}</h2>
                        </div>
                        <div className={styles.toolbar}>
                            <button
                                className={styles.exitButton}
                                onClick={this.props.closeCallback}
                            >
                                <span className="sr-only">{t('general.close')}</span>
                                <i className="fa fa-close fa-3" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                    <div className={styles.mainContainer}>
                        {t('ckeditor.snapshots.snapshotsInfo')}<br /><br />
                        {t('ckeditor.snapshots.numberOfSnapshotsAvailable', { numberOfRevisions: this.props.snapshots.length })}
                        &nbsp;&nbsp;
                        {t('ckeditor.snapshots.selectARevisionToRestore')}
                        <ul className="snapshotsList">
                            {
                                this.props.snapshots
                                    .sort((a, b) => {
                                        return new Date(b.time).getTime() - new Date(a.time).getTime();
                                    })
                                    .map((snapshot) => {
                                        return (<SnapshotListItem
                                            key={snapshot.time}
                                            name={this.formatDateTime(snapshot.time)}
                                            snapshot={snapshot}
                                            selectSnapshot={this.selectSnapshot}
                                        />);
                                    })
                            }
                        </ul>
                        {
                            this.state.selectedSnapshot ?
                                <div className={styles.actionFooter}>
                                    <div className={styles.footerTextWrapper}>
                                        <span
                                            dangerouslySetInnerHTML={
                                                {
                                                    __html: t('ckeditor.snapshots.doYouWantToRestore', {
                                                        snapshotName: this.formatDateTime(this.state.selectedSnapshot.time),
                                                    }),
                                                }
                                            }
                                        />
                                        &nbsp;
                                        {t('ckeditor.snapshots.yourCurrentResponseWillBeOverwritten')}
                                    </div>
                                    <div className={styles.footerButtonWrapper}>
                                        <button
                                            className={`${styles.cancelButton} btn `}
                                            onClick={this.onCancelButtonClick}
                                        >
                                            {t('general.cancel')}
                                        </button>
                                        <button
                                            className={`${styles.restoreButton} btn`}
                                            onClick={this.onRestoreButtonClick}
                                        >
                                            {t('general.continue')}
                                        </button>
                                    </div>
                                </div> : null
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

export function mapStateToProps(state, ownProps) {
    const { ckeditor, closeCallback, interactionId, questionId } = ownProps;
    return {
        closeCallback,
        ckeditor,
        interactionId,
        questionId,
        snapshots: snapshotsService.getSnapshots(questionId, interactionId, state),
    };
}

const SnapshotsModalContainer = connect(mapStateToProps)(SnapshotsModal);

export default SnapshotsModalContainer;
